module.exports = __webpack_public_path__ + "media/images/flags/64/Cape-Verde-4e0db127bc41761635a3d953a25477e5.png";